import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * SPA redirect that preserves query string + interpolates :params from URL.
 * Usage: <Route path="/instructor/courses" element={<LegacyRedirect to="/instructor/teaching/courses" />} />
 *        <Route path="/instructor/courses/:courseId" element={<LegacyRedirect to="/instructor/teaching/courses/:courseId" />} />
 */
export default function LegacyRedirect({ to }) {
  const params = useParams();
  const location = useLocation();

  // Interpolate :name segments from current params
  let target = to;
  Object.entries(params).forEach(([k, v]) => {
    if (v != null) target = target.replace(`:${k}`, v);
  });

  // Append remaining wildcard rest if present
  if (params["*"]) target = `${target}/${params["*"]}`.replace(/\/+$/, target.endsWith("/") ? "/" : "");

  return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
}
